import { Observable } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ServiceResult } from '@shared/helper/service-result';
import { TServiceResult } from '@shared/helper/t-service-result';
import { LocalRepository } from '@shared/helper/local-repository';
import { CreateBookmarkModel } from '../handler/bookmark-handler.service';
import { PageList } from '@shared/model/categoryAndSearch/pageList-model';
import { HttpBaseService } from '@shared/service/base_services/http_base.service';
import { ActivitiesAggrigatorModel } from '@shared/model/activities-aggrigator-model';
import { SearchFilterModel } from '@shared/model/categoryAndSearch/search-filter-model';

@Injectable({
  providedIn: 'root'
})
export class BookmarkAggrigatorService extends HttpBaseService {

  constructor() {
    const repo = inject(LocalRepository);
    const http = inject(HttpClient);

    super(repo, http, 'v1/bkmAggr');
  }

  mark(bookmark: CreateBookmarkModel): Observable<ServiceResult> {
    return this.http.post<ServiceResult>(`${this.apiUrl}/mark/${bookmark.objectId}?objectTypeId=${bookmark.objectType}`, null);
  }

  getMyBookmarks(searchFilter: SearchFilterModel, objectType?: number): Observable<TServiceResult<PageList<ActivitiesAggrigatorModel>>> {
    if (objectType == 0) {
      return this.http.post<TServiceResult<PageList<ActivitiesAggrigatorModel>>>(`${this.apiUrl}/GetMyBookmarks`, searchFilter);
    }
    return this.http.post<TServiceResult<PageList<ActivitiesAggrigatorModel>>>(`${this.apiUrl}/GetMyBookmarks?objectType=${objectType}`, searchFilter);
  }

}
